import { h, FunctionalComponent } from "preact";
import { useCollection } from "./CollectionContext";

// Define the type for sort options
type SortOption = {
  value: string;
  label: string;
};

// Define the available sort options
const sortOptions: SortOption[] = [
  { value: "manual", label: window.themeVars.strings.collection.sortByManual },
  {
    value: "title-ascending",
    label: window.themeVars.strings.collection.sortByTitleAsc,
  },
  {
    value: "title-descending",
    label: window.themeVars.strings.collection.sortByTitleDesc,
  },
  {
    value: "price-ascending",
    label: window.themeVars.strings.collection.sortByPriceAsc,
  },
  {
    value: "price-descending",
    label: window.themeVars.strings.collection.sortByPriceDesc,
  },
  {
    value: "created-ascending",
    label: window.themeVars.strings.collection.sortByCreatedAsc,
  },
  {
    value: "created-descending",
    label: window.themeVars.strings.collection.sortByCreatedDesc,
  },
  {
    value: "best-selling",
    label: window.themeVars.strings.collection.sortByBestSelling,
  },
];

// SortSelect component to handle sorting functionality
const SortSelect: FunctionalComponent = () => {
  const { selectedSort, setSelectedSort } = useCollection();

  // Handle the change event for sort selection
  const handleSortChange = (event: Event) => {
    const target = event.target as HTMLSelectElement;
    setSelectedSort(target.value);
  };

  return (
    <div className="sort-select">
      <label className="text-md-body--semi-bold" htmlFor="product-sort">
        {window.themeVars.strings.collection.sortBy}
      </label>

      <select
        id="product-sort"
        value={selectedSort}
        onChange={handleSortChange}
        className="sort-select__select text-sm"
      >
        {sortOptions.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      <span
        className="sort-select__chevron"
        dangerouslySetInnerHTML={{
          __html: window.themeVars.icons.chevronDown,
        }}
      ></span>
    </div>
  );
};

export default SortSelect;
